<template>
    <div class="container-fluid">
      <div class="row">
        <main class="col-12 px-md-4 container-view">
          <router-view />
        </main>
      </div>
      <Toast />
    </div>
  </template>
  
  <script>
  import { onMounted, onUnmounted } from 'vue';
  import { mapActions } from 'vuex';
  import Toast from './components/Toast.vue';
  import { useToast } from './composables/useToast';
  import { emitter } from './store';

  export default {
    name: 'App',
    components: { Toast },
    setup() {
      const { showSuccess, showError } = useToast();
      onMounted(() => {
        emitter.on('toastSuccess', showSuccess);
        emitter.on('toastError', showError);
      });
      onUnmounted(() => {
        emitter.off('toastSuccess', showSuccess);
        emitter.off('toastError', showError);
      });
    },
    created() {
      if (this.$route?.path !== '/sso/callback') {
        this.preloadData();
      }
    },
    methods: {
      ...mapActions(['preloadData'])
    }
  };
  </script>
  
  <style lang="scss">
  body {
      background-color: $gray-bg;
  }
  </style>
  